module.exports = __webpack_public_path__ + "static/media/filterIcon.cfcca8e7.svg";